import { getAgentNotes } from "@/services/api/agents/notes";
import { NoteObj } from "@/types/interfaces/notes";
import { useQuery } from "@tanstack/react-query";

export const isNoteOpen = (note: NoteObj) => note.active && !note.reviewed;

export const isNoteOverdue = (note: NoteObj) => {
  if (!isNoteOpen(note) || !note.reviewOn) return false;
  const reviewOn = new Date(note.reviewOn);
  return !isNaN(reviewOn.getTime()) && reviewOn.getTime() < Date.now();
};

// shared by the overview, tab badge and notes tab; react-query dedupes the request
const useAgentNotes = (email: string) => {
  const query = useQuery({
    queryKey: ["agentNotes", email],
    queryFn: ({ queryKey }) => getAgentNotes({ toEmail: queryKey[1] }),
    enabled: !!email,
  });

  const notes = query.data?.notes || [];
  const openNotes = notes.filter(isNoteOpen);

  return {
    query,
    notes,
    openNotes,
    overdueNotes: openNotes.filter(isNoteOverdue),
  };
};

export default useAgentNotes;
